// extracted by mini-css-extract-plugin
export var sliderRange = "_qt-2";
export var sliderRoot = "_qt-0";
export var sliderThumb = "_qt-3";
export var sliderTrack = "_qt-1";